// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
import React from "react";

const MeetingNavbar = () => {
  return <div></div>;
};

export default MeetingNavbar;
